import { apiClient } from '~/adapters/apiClient';
import log from '~/logger';
export async function fetchProductInstances(params) {
    try {
        const queryParams = params
            ? {
                projectId: params.projectId,
                expressionId: params.expressionId,
                genderId: params.genderId,
                page: params.page,
                count: params.count
            }
            : undefined;
        const data = await apiClient.get('/product_planning/product_instances/v1', 'pulse-projects', queryParams);
        return data;
    }
    catch (error) {
        log.error('Failed to fetch product instances', {
            error: error instanceof Error ? error.message : 'Unknown error',
            params
        });
        return { pages: {}, objects: [] };
    }
}
export async function fetchProductInstancesArray(params) {
    const page = await fetchProductInstances(params);
    return page.objects ?? [];
}
export async function fetchProductInstanceById(id) {
    try {
        const data = await apiClient.get(`/product_planning/product_instances/v1/${id}`, 'pulse-projects');
        return data;
    }
    catch (error) {
        log.error('Failed to fetch product instance by id', {
            error: error instanceof Error ? error.message : 'Unknown error',
            id
        });
        return null;
    }
}
export async function fetchProductInstancesByExpression(expressionId) {
    try {
        const instances = await fetchProductInstancesArray({
            expressionId,
            count: 1000
        });
        return instances;
    }
    catch (error) {
        log.error('Failed to fetch product instances by expression', {
            error: error instanceof Error ? error.message : 'Unknown error',
            expressionId
        });
        return [];
    }
}
